module.exports = __webpack_public_path__ + "static/media/Logos for Charity Page.aa327814.png";